'use client';
import { rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
    if (placement === "center" || arrowPosition === "center") {
        return {
            top: arrowY
        };
    }
    if (placement === "end") {
        return {
            bottom: arrowOffset
        };
    }
    if (placement === "start") {
        return {
            top: arrowOffset
        };
    }
    return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
    if (placement === "center" || arrowPosition === "center") {
        return {
            left: arrowX
        };
    }
    if (placement === "end") {
        var _obj;
        return _obj = {}, _obj[dir === "ltr" ? "right" : "left"] = arrowOffset, _obj;
    }
    if (placement === "start") {
        var _obj1;
        return _obj1 = {}, _obj1[dir === "ltr" ? "left" : "right"] = arrowOffset, _obj1;
    }
    return {};
}
var radiusLookup = {
    bottom: "borderTopLeftRadius",
    left: "borderTopRightRadius",
    right: "borderBottomLeftRadius",
    top: "borderBottomRightRadius"
};
function getArrowPositionStyles(param) {
    var position = param.position, arrowSize = param.arrowSize, arrowOffset = param.arrowOffset, arrowRadius = param.arrowRadius, arrowPosition = param.arrowPosition, arrowX = param.arrowX, arrowY = param.arrowY, dir = param.dir;
    var _position_split = position.split("-"), side = _position_split[0], tmp = _position_split[1], placement = tmp === void 0 ? "center" : tmp;
    var _obj;
    var baseStyles = (_obj = {
        width: rem(arrowSize),
        height: rem(arrowSize),
        transform: "rotate(45deg)",
        position: "absolute"
    }, _obj[radiusLookup[side]] = rem(arrowRadius), _obj);
    var arrowPlacement = rem(-(arrowSize / 2));
    if (side === "left") {
        return _extends({}, baseStyles, horizontalSide(placement, arrowY, arrowOffset, arrowPosition), {
            right: arrowPlacement,
            borderLeftColor: "transparent",
            borderBottomColor: "transparent"
        });
    }
    if (side === "right") {
        return _extends({}, baseStyles, horizontalSide(placement, arrowY, arrowOffset, arrowPosition), {
            left: arrowPlacement,
            borderRightColor: "transparent",
            borderTopColor: "transparent"
        });
    }
    if (side === "top") {
        return _extends({}, baseStyles, verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir), {
            bottom: arrowPlacement,
            borderTopColor: "transparent",
            borderLeftColor: "transparent"
        });
    }
    if (side === "bottom") {
        return _extends({}, baseStyles, verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir), {
            top: arrowPlacement,
            borderBottomColor: "transparent",
            borderRightColor: "transparent"
        });
    }
    return {};
}

export { getArrowPositionStyles };
